import { PrintService } from '@feature/_app_modules/printing/services/print.service';
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: "[mojoPrintImmediate]"
})
export class MojoPrintImmediate implements AfterViewInit {

  @Input()
  headCss: string[];
  @Input()
  displayHeader: boolean = true;

  constructor(private elementRef: ElementRef,
              private printService: PrintService) { }
  ngAfterViewInit(): void {
      this.printService.print(this.elementRef, this.displayHeader, this.headCss);
  }

}
